import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "profile-creation-wizard__side" }
const _hoisted_2 = { class: "profile-creation-wizard__side-mobile" }
const _hoisted_3 = ["close-label"]
const _hoisted_4 = { slot: "bottom-sheet-content" }
const _hoisted_5 = ["innerHTML"]
const _hoisted_6 = { class: "profile-creation-wizard__side-desktop" }
const _hoisted_7 = { class: "profile-creation-wizard__side-container profile-creation-wizard__side-container" }
const _hoisted_8 = { class: "profile-creation-wizard__side-description" }
const _hoisted_9 = { class: "profile-creation-wizard__side-iconTitle" }
const _hoisted_10 = ["innerHTML"]

import {useTranslation} from '@malt/vue3-use';
    import {useStore} from 'vuex';

    
export default /*@__PURE__*/_defineComponent({
  __name: 'YourEducationSide',
  setup(__props) {

    const {msg} = useTranslation();

    const store = useStore();
    const sideDescription = msg(`profile.creation.completion.wizard.v2.side.education.${store.state.isFunnelStrategy ? 'strategy.' : ''}description`);

return (_ctx: any,_cache: any) => {
  const _component_VJoyIcon = _resolveComponent("VJoyIcon")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("joy-bottom-sheet", {
        id: "completion-your-education-bottom-sheet",
        "close-label": _ctx.$msg('general.close')
      }, [
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("h2", null, _toDisplayString(_unref(msg)('profile.creation.completion.wizard.v2.side.education.title')), 1),
          _createElementVNode("p", { innerHTML: _unref(sideDescription) }, null, 8, _hoisted_5)
        ])
      ], 8, _hoisted_3)
    ]),
    _createElementVNode("div", _hoisted_6, [
      _createElementVNode("div", _hoisted_7, [
        _createElementVNode("div", _hoisted_8, [
          _createElementVNode("div", _hoisted_9, [
            _createVNode(_component_VJoyIcon, {
              name: "freelancer-placeholder",
              size: "small"
            }),
            _createElementVNode("strong", null, _toDisplayString(_unref(msg)('profile.creation.completion.wizard.v2.side.education.title')), 1)
          ]),
          _createElementVNode("p", { innerHTML: _unref(sideDescription) }, null, 8, _hoisted_10)
        ])
      ])
    ])
  ]))
}
}

})